export default String.raw`
<div class="discounts-list-js container-js" data-template="partials/customer-profile/discounts/discount-details.html">
    {% include 'partials/customer-profile/discounts/discount-list.html' -%}
</div>

`